document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const link = event.target.closest('.mobile-menu a');
  if (!link) return;
  const menu = link.closest('details');
  if (menu) menu.removeAttribute('open');
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const form = select.closest('form');
  const idInput = form && form.querySelector('input[name="id"]');
  if (idInput) idInput.value = select.value;
});
